export default "__VITE_ASSET__BWevErO7__"